export default __webpack_public_path__ + "static/media/laptop_and_mobile.b8390f66.png";